module.exports = __webpack_public_path__ + "static/img/img-cpfw_ad.5d9850ce.jpg";